import { default as indexn5MEgUhIZQMeta } from "/home/runner/work/pennywhales-tma/pennywhales-tma/pages/index.vue?macro=true";
import { default as winnerlistMQCxg26WKzMeta } from "/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/redotpay/winnerlist.vue?macro=true";
import { default as bonusdistZUdxsjD2wGMeta } from "/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/salesreport/bonusdist.vue?macro=true";
import { default as bonusentitlevXQZN9JDQsMeta } from "/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/salesreport/bonusentitle.vue?macro=true";
import { default as passive_45miningM1u4nc7vfpMeta } from "/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/salesreport/passive-mining.vue?macro=true";
import { default as reportviewg6XUVZbDZqMeta } from "/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/salesreport/reportview.vue?macro=true";
import { default as taskcheckavNo1G2njBMeta } from "/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/taskprogress/taskcheck.vue?macro=true";
import { default as withdrawList4UPQdwVgp4Meta } from "/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/withdraw/request/withdrawList.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/pennywhales-tma/pennywhales-tma/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "pennywhalestma-admin-redotpay-winnerlist",
    path: "/pennywhalestma/admin/redotpay/winnerlist",
    component: () => import("/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/redotpay/winnerlist.vue").then(m => m.default || m)
  },
  {
    name: "pennywhalestma-admin-salesreport-bonusdist",
    path: "/pennywhalestma/admin/salesreport/bonusdist",
    component: () => import("/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/salesreport/bonusdist.vue").then(m => m.default || m)
  },
  {
    name: "pennywhalestma-admin-salesreport-bonusentitle",
    path: "/pennywhalestma/admin/salesreport/bonusentitle",
    component: () => import("/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/salesreport/bonusentitle.vue").then(m => m.default || m)
  },
  {
    name: "pennywhalestma-admin-salesreport-passive-mining",
    path: "/pennywhalestma/admin/salesreport/passive-mining",
    component: () => import("/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/salesreport/passive-mining.vue").then(m => m.default || m)
  },
  {
    name: "pennywhalestma-admin-salesreport-reportview",
    path: "/pennywhalestma/admin/salesreport/reportview",
    component: () => import("/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/salesreport/reportview.vue").then(m => m.default || m)
  },
  {
    name: "pennywhalestma-admin-taskprogress-taskcheck",
    path: "/pennywhalestma/admin/taskprogress/taskcheck",
    component: () => import("/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/taskprogress/taskcheck.vue").then(m => m.default || m)
  },
  {
    name: "pennywhalestma-admin-withdraw-request-withdrawList",
    path: "/pennywhalestma/admin/withdraw/request/withdrawList",
    component: () => import("/home/runner/work/pennywhales-tma/pennywhales-tma/pages/pennywhalestma/admin/withdraw/request/withdrawList.vue").then(m => m.default || m)
  }
]